import Img from 'gatsby-image';
import { chunk, first, sum } from 'lodash';
import React from 'react';
import { Box } from 'rebass';

const Gallery = props => {
  console.log('PROPS', props)

  const half = Math.ceil(props.images.length / 2);    
  const firstHalf = props.images.slice(0, half)
  const secondHalf = props.images.slice(-half)

  return (
    <div className='gallery'>
      <div id='top-row'>
        {
          firstHalf.map(item =>
            <img className='gallery-image' src={item.image.childImageSharp.fluid.originalImg}/>)
        }
      </div>
      <div id='bottom-row'>
        {
          secondHalf.map(item =>
            <img className='gallery-image' src={item.image.childImageSharp.fluid.originalImg}/>)
        }
      </div>
    </div>
  );
};

export default Gallery;
